import { render, staticRenderFns } from "./PhoneDialModal.vue?vue&type=template&id=f328f0dc"
import script from "./PhoneDialModal.vue?vue&type=script&lang=js"
export * from "./PhoneDialModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneDialModal.vue?vue&type=style&index=0&id=f328f0dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports